import React from 'react';



/**
 * News Item Component
 */
const NewsItem = (props) => {
    const { 
        data = null,
        ...restProps 
    } = props;
    if ( !data ) return;

    const { 
        title = null,
        thumbnail = null,
        url = null,
        excerpt = null,
        date = null,
        ...restData 
    } = data;

    // Title
    let titleStr;
    if ( title ) {
        titleStr = (
            <div className="fusion-title title fusion-title-32 fusion-sep-none fusion-title-center fusion-title-text fusion-title-size-three" >
                <h2 className="fusion-title-heading title-heading-center">{ title }</h2>
            </div>
        );
    }
    
    // Image
    let imageStr;
    if ( thumbnail ) {
        imageStr = (
            <div className="fusion-classNameic-product-image-wrapper fusion-woo-product-image fusion-post-card-image fusion-post-card-image-1" data-layout="rollover">
                <div className="fusion-image-wrapper" aria-haspopup="true">
                    <img decoding="async" width="1024" height="576" src={thumbnail} className="attachment-full size-full wp-post-image lazyautosizes lazyloaded" alt="" />
                    <div className="fusion-rollover">
                        <div className="fusion-rollover-content">
                            <a className="fusion-link-wrapper" href={url} aria-label={title}></a>
                        </div>
                    </div>
                </div>
            </div>
        );
    }


    return (
        <li className="fusion-layout-column fusion_builder_column fusion-builder-column-16 fusion-flex-column post-card fusion-grid-column fusion-post-cards-grid-column newsItem">
            <div className="fusion-column-wrapper fusion-column-has-shadow fusion-flex-justify-content-flex-start fusion-content-layout-column">
                { imageStr }
                { titleStr }
                <div className="fusion-meta-tb fusion-meta-tb-1 floated">
                    <span className="fusion-tb-published-date">{ date }</span>
                </div>
                <div className="fusion-content-tb fusion-content-tb-1">
                    <p>{ excerpt }</p>
                </div>
                <div className="fusion-separator fusion-full-width-sep"></div>
                <div>
                    <a className="fusion-button button-flat fusion-button-default-size button-default fusion-button-default button-11 fusion-button-span-yes fusion-button-default-type" target="_self" href={url}>
                        <span className="fusion-button-text">READ MORE</span>
                    </a>
                </div>
            </div>
        </li>
    );
}



/**
 * Export
 */
export { NewsItem };